/**
 * Order bilgilerini Purchase Order formatına dönüştürür
 * OPTİMİZE EDİLMİŞ VERSİYON - OTHER LABEL DESTEĞİ
 */

export const mapOrderToPOData = (order, poCount = 1) => {
    if (!order) {
        console.warn('⚠️ PODataMapper: Order data bulunamadı');
        return null;
    }

    try {
        // 🔥 OPTİMİZE: Tarih formatlama
        const now = new Date();
        const dateStr = `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getFullYear()).slice(-2)}`;

        // 🔥 OPTİMİZE: PO Number formatı
        const orderNumber = order.orderNumber?.replace('#', '') || '0000';
        const poNumber = `PO${dateStr}#${orderNumber}-${String(poCount).padStart(3, '0')}`;

        // 🔥 OPTİMİZE: Vendor adı çıkarma
        const firstItem = order.items?.[0];
        const vendorName = firstItem?.productTitle?.split(' ')[0] || 'Supplier';

        // 🔥 OPTİMİZE: Müşteri adı
        const customerName = `${order.customerFirstName || ''} ${order.customerLastName || ''}`.trim() || 'Customer';

        return {
            // Header Information
            poNumber: poNumber,
            date: now.toLocaleDateString('en-US'),
            orderDate: new Date(order.orderDate).toLocaleDateString('en-US'),

            // Company Information (BILL TO)
            billTo: {
                company: "Palmyra 1 Trading LLC",
                address: "2224 NJ-37 E, Suite 3",
                cityStateZip: "Toms River, NJ, 08753",
                website: "",
                email: "support@medidepot.com",
                phone: "+1 848 281 3416"
            },

            // VENDOR Information
            vendor: {
                notes: vendorName + '\n\n\n',
                accountNumber: ""
            },

            // Customer Information (SHIP TO)
            shipTo: {
                name: customerName,
                address: order.shippingAddress || 'Address not available',
                email: order.customerEmail || 'Email not available'
            },

            // Items - 🔥 OPTİMİZE: Default değerlerle güvenli mapping
            items: order.items?.map(item => ({
                itemCode: item.sku || 'N/A',
                description: item.productTitle || 'No description',
                quantity: item.quantity || 0,
                unitPrice: item.unitPrice || 0,
                total: item.totalPrice || 0
            })) || [],

            // Totals - 🔥 OPTİMİZE: Safe default values
            subtotal: order.subtotalPrice || 0,
            handling: 0,
            handlingLabel: "HANDLING", // 🔥 YENİ
            shipping: order.totalShipping || 0,
            shippingLabel: "SHIPPING", // 🔥 YENİ
            other: 0,
            otherLabel: "OTHER", // 🔥 YENİ
            total: order.totalPrice || 0,

            // Comments
            comments: "DROPSHIP ORDER - Please ship directly to customer address above."
        };
    } catch (error) {
        console.error('❌ PODataMapper: Data mapping hatası:', error);
        return null;
    }
};

/**
 * 🔥 YENİ: PO Data validasyon fonksiyonu
 */
export const validatePOData = (poData) => {
    if (!poData) return false;

    const requiredFields = ['poNumber', 'date', 'billTo', 'vendor', 'shipTo', 'items'];
    const missingFields = requiredFields.filter(field => !poData[field]);

    if (missingFields.length > 0) {
        console.warn('⚠️ PO Data validasyon hatası - Eksik alanlar:', missingFields);
        return false;
    }

    return true;
};

/**
 * 🔥 YENİ: PO Number generator (isteğe bağlı)
 */
export const generatePONumber = (orderNumber, poCount = 1) => {
    const now = new Date();
    const dateStr = `${String(now.getDate()).padStart(2, '0')}${String(now.getMonth() + 1).padStart(2, '0')}${String(now.getFullYear()).slice(-2)}`;
    const cleanOrderNumber = orderNumber?.replace('#', '') || '0000';
    return `PO${dateStr}#${cleanOrderNumber}-${String(poCount).padStart(3, '0')}`;
};